// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Экран 7 «Окно чата на сайте» (утверждён 28.10.2026). */
.wg-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  align-items: flex-start;
}
.wg-main {
  flex: 999 1 560px;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.wg-side {
  flex: 1 1 340px;
  max-width: 440px;
  position: sticky;
  top: 72px;
}
.wg-savebar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.wg-card {
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.wg-text {
  color: var(--v2-text-2);
}
.wg-code {
  margin: 0;
  background: #1f2937;
  color: #f9fafb;
  border-radius: 10px;
  padding: 12px 14px;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12.5px;
  white-space: pre-wrap;
  word-break: break-all;
}
.wg-row-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.wg-sep {
  border-top: 1px solid var(--v2-border-soft);
}
.wg-label {
  font-weight: 600;
  font-size: 13px;
}
.wg-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}
.wg-two {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(330px, 1fr));
  gap: 14px;
}
.wg-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}
.wg-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 30px;
  padding: 0 6px 0 10px;
  border-radius: 8px;
  background: var(--v2-bg);
  border: 1px solid var(--v2-border);
  font-size: 13px;
}
.wg-chip button {
  border: 0;
  background: none;
  cursor: pointer;
  color: var(--v2-muted);
  font-size: 11px;
  padding: 2px 4px;
}
.wg-chip-add {
  height: 30px;
  min-width: 170px;
  border: 1px dashed #d1d5db;
  border-radius: 8px;
  padding: 0 10px;
  font: inherit;
  font-size: 13px;
  outline: none;
}
.wg-chip-add:focus {
  border-color: var(--v2-primary);
  border-style: solid;
}
.wg-warn {
  background: var(--v2-orange-bg);
  color: #7c2d12;
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 13px;
}
.wg-photo {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.wg-ava {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  object-fit: cover;
  flex: none;
}
.wg-ava.is-letter {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffedd5;
  color: #c2410c;
  font-weight: 700;
}
.wg-colors {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.wg-swatch {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  border: 0;
  cursor: pointer;
  padding: 0;
  outline-offset: 2px;
  position: relative;
}
.wg-swatch.is-on {
  outline: 2px solid var(--v2-primary);
}
.wg-picker {
  display: inline-block;
  overflow: hidden;
  border: 1px solid var(--v2-border);
}
.wg-picker input {
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;
  width: 100%;
  height: 100%;
}
.wg-picker span {
  display: block;
  width: 100%;
  height: 100%;
}
.wg-vsep {
  width: 1px;
  height: 22px;
  background: var(--v2-border);
}
.wg-hex {
  width: 96px;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
}
.wg-hex.is-err {
  border-color: #dc2626;
}
.wg-seg {
  display: inline-flex;
  flex-wrap: wrap;
  background: #f3f4f6;
  border-radius: 10px;
  padding: 3px;
  gap: 2px;
  align-self: flex-start;
}
.wg-seg button {
  border: 0;
  background: none;
  font: inherit;
  font-size: 13px;
  height: 32px;
  padding: 0 12px;
  border-radius: 8px;
  color: var(--v2-muted);
  cursor: pointer;
  white-space: nowrap;
}
.wg-seg button.is-on {
  background: #fff;
  color: var(--v2-primary);
  font-weight: 600;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
}
.wg-check {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  margin-left: 8px;
  cursor: pointer;
}

/* Превью */
.wp {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.wp-cap {
  font-size: 12px;
  font-weight: 700;
  color: var(--v2-muted);
  text-transform: uppercase;
  letter-spacing: 0.4px;
}
.wp-browser {
  border: 1px solid var(--v2-border);
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
}
.wp-bar {
  display: flex;
  align-items: center;
  gap: 6px;
  height: 30px;
  padding: 0 10px;
  background: #f9fafb;
  border-bottom: 1px solid var(--v2-border-soft);
  font-size: 11px;
  color: var(--v2-muted);
}
.wp-bar i {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #d1d5db;
}
.wp-bar span {
  margin-left: 8px;
}
.wp-page {
  position: relative;
  height: 520px;
  overflow: hidden;
}
.wp-lines {
  padding: 18px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.wp-lines span {
  height: 10px;
  border-radius: 4px;
  background: #f3f4f6;
}
.wp-win {
  position: absolute;
  right: 14px;
  bottom: 82px;
  width: 300px;
  max-width: calc(100% - 28px);
  height: 360px;
  background: #fff;
  color: #111827;
  border-radius: 14px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.16);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.wp-win.is-left {
  right: auto;
  left: 14px;
}
.wp-win.is-dark {
  background: #111827;
  color: #f9fafb;
}
.wp-head {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border-bottom: 1px solid rgba(127, 127, 127, 0.15);
}
.wp-ava {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: cover;
  flex: none;
}
.wp-ava.is-letter {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffedd5;
  color: #c2410c;
  font-weight: 700;
  font-size: 13px;
}
.wp-name {
  font-weight: 700;
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.wp-online {
  font-size: 11px;
  color: #16a34a;
}
.wp-x {
  font-size: 12px;
  opacity: 0.5;
}
.wp-msgs {
  flex: 1;
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 12.5px;
  overflow: hidden;
}
.wp-bot,
.wp-me {
  max-width: 85%;
  padding: 8px 10px;
  border-radius: 12px;
  line-height: 1.4;
}
.wp-bot {
  background: #f3f4f6;
  align-self: flex-start;
}
.wp-win.is-dark .wp-bot {
  background: #1f2937;
}
.wp-me {
  align-self: flex-end;
}
.wp-input {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 10px 10px;
  padding: 6px 6px 6px 10px;
  border-top: 1px solid rgba(127, 127, 127, 0.15);
  font-size: 12px;
  opacity: 0.85;
}
.wp-input > span:first-child {
  flex: 1;
  opacity: 0.6;
}
.wp-send {
  width: 26px;
  height: 26px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
}
.wp-launcher {
  position: absolute;
  right: 14px;
  bottom: 14px;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}
.wp-launcher.is-left {
  right: auto;
  left: 14px;
}
.wp-invite {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  background: #fff;
  border: 1px solid var(--v2-border);
  border-radius: 12px;
  padding: 12px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.06);
}
.wp-invite.is-dark {
  background: #111827;
  color: #f9fafb;
  border-color: #111827;
}
.wp-invite-text {
  font-size: 12.5px;
  line-height: 1.4;
}
@media (max-width: 1180px) {
  .wg-side {
    position: static;
    max-width: none;
  }
}
.v2-topbar .wg-savebar {
  flex-wrap: nowrap;
  min-width: 0;
}
.v2-topbar .wg-savebar > span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.wg-save-short {
  display: none;
  color: var(--v2-orange);
  font-weight: 600;
}
@media (max-width: 1100px) {
  .v2-topbar .wg-savebar > .wg-save-long {
    display: none;
  }
  .v2-topbar .wg-savebar > .wg-save-short {
    display: inline;
  }
}
.wg-swatch:focus-visible,
.wg-seg button:focus-visible,
.wg-picker:focus-within {
  outline: 2px solid var(--v2-blue);
  outline-offset: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/channels/widget.css"],"names":[],"mappings":"AAAA,yDAAyD;AACzD;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,uBAAuB;AACzB;AACA;EACE,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,2DAA2D;EAC3D,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;AACA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,wBAAwB;EACxB,kCAAkC;EAClC,eAAe;AACjB;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,eAAe;EACf,aAAa;AACf;AACA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;AACA;EACE,+BAA+B;EAC/B,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,UAAU;EACV,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,WAAW;EACX,YAAY;AACd;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;AACA;EACE,UAAU;EACV,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,2DAA2D;AAC7D;AACA;EACE,qBAAqB;AACvB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,QAAQ;EACR,sBAAsB;AACxB;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,yCAAyC;AAC3C;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,8CAA8C;EAC9C,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kDAAkD;AACpD;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,OAAO;EACP,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;EAEE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,+CAA+C;EAC/C,eAAe;EACf,aAAa;AACf;AACA;EACE,OAAO;EACP,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;AAC3C;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;AACF;AACA;;;EAGE,iCAAiC;EACjC,mBAAmB;AACrB","sourcesContent":["/* Экран 7 «Окно чата на сайте» (утверждён 28.10.2026). */\n.wg-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 18px;\n  align-items: flex-start;\n}\n.wg-main {\n  flex: 999 1 560px;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n.wg-side {\n  flex: 1 1 340px;\n  max-width: 440px;\n  position: sticky;\n  top: 72px;\n}\n.wg-savebar {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n.wg-card {\n  padding: 18px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.wg-text {\n  color: var(--v2-text-2);\n}\n.wg-code {\n  margin: 0;\n  background: #1f2937;\n  color: #f9fafb;\n  border-radius: 10px;\n  padding: 12px 14px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n  font-size: 12.5px;\n  white-space: pre-wrap;\n  word-break: break-all;\n}\n.wg-row-wrap {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n.wg-sep {\n  border-top: 1px solid var(--v2-border-soft);\n}\n.wg-label {\n  font-weight: 600;\n  font-size: 13px;\n}\n.wg-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n}\n.wg-two {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(330px, 1fr));\n  gap: 14px;\n}\n.wg-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n}\n.wg-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 30px;\n  padding: 0 6px 0 10px;\n  border-radius: 8px;\n  background: var(--v2-bg);\n  border: 1px solid var(--v2-border);\n  font-size: 13px;\n}\n.wg-chip button {\n  border: 0;\n  background: none;\n  cursor: pointer;\n  color: var(--v2-muted);\n  font-size: 11px;\n  padding: 2px 4px;\n}\n.wg-chip-add {\n  height: 30px;\n  min-width: 170px;\n  border: 1px dashed #d1d5db;\n  border-radius: 8px;\n  padding: 0 10px;\n  font: inherit;\n  font-size: 13px;\n  outline: none;\n}\n.wg-chip-add:focus {\n  border-color: var(--v2-primary);\n  border-style: solid;\n}\n.wg-warn {\n  background: var(--v2-orange-bg);\n  color: #7c2d12;\n  border-radius: 10px;\n  padding: 10px 12px;\n  font-size: 13px;\n}\n.wg-photo {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n.wg-ava {\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  object-fit: cover;\n  flex: none;\n}\n.wg-ava.is-letter {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #ffedd5;\n  color: #c2410c;\n  font-weight: 700;\n}\n.wg-colors {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n.wg-swatch {\n  width: 30px;\n  height: 30px;\n  border-radius: 8px;\n  border: 0;\n  cursor: pointer;\n  padding: 0;\n  outline-offset: 2px;\n  position: relative;\n}\n.wg-swatch.is-on {\n  outline: 2px solid var(--v2-primary);\n}\n.wg-picker {\n  display: inline-block;\n  overflow: hidden;\n  border: 1px solid var(--v2-border);\n}\n.wg-picker input {\n  position: absolute;\n  inset: 0;\n  opacity: 0;\n  cursor: pointer;\n  width: 100%;\n  height: 100%;\n}\n.wg-picker span {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n.wg-vsep {\n  width: 1px;\n  height: 22px;\n  background: var(--v2-border);\n}\n.wg-hex {\n  width: 96px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n}\n.wg-hex.is-err {\n  border-color: #dc2626;\n}\n.wg-seg {\n  display: inline-flex;\n  flex-wrap: wrap;\n  background: #f3f4f6;\n  border-radius: 10px;\n  padding: 3px;\n  gap: 2px;\n  align-self: flex-start;\n}\n.wg-seg button {\n  border: 0;\n  background: none;\n  font: inherit;\n  font-size: 13px;\n  height: 32px;\n  padding: 0 12px;\n  border-radius: 8px;\n  color: var(--v2-muted);\n  cursor: pointer;\n  white-space: nowrap;\n}\n.wg-seg button.is-on {\n  background: #fff;\n  color: var(--v2-primary);\n  font-weight: 600;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);\n}\n.wg-check {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  margin-left: 8px;\n  cursor: pointer;\n}\n\n/* Превью */\n.wp {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.wp-cap {\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--v2-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n}\n.wp-browser {\n  border: 1px solid var(--v2-border);\n  border-radius: 12px;\n  overflow: hidden;\n  background: #fff;\n}\n.wp-bar {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  height: 30px;\n  padding: 0 10px;\n  background: #f9fafb;\n  border-bottom: 1px solid var(--v2-border-soft);\n  font-size: 11px;\n  color: var(--v2-muted);\n}\n.wp-bar i {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #d1d5db;\n}\n.wp-bar span {\n  margin-left: 8px;\n}\n.wp-page {\n  position: relative;\n  height: 520px;\n  overflow: hidden;\n}\n.wp-lines {\n  padding: 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n.wp-lines span {\n  height: 10px;\n  border-radius: 4px;\n  background: #f3f4f6;\n}\n.wp-win {\n  position: absolute;\n  right: 14px;\n  bottom: 82px;\n  width: 300px;\n  max-width: calc(100% - 28px);\n  height: 360px;\n  background: #fff;\n  color: #111827;\n  border-radius: 14px;\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.16);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n.wp-win.is-left {\n  right: auto;\n  left: 14px;\n}\n.wp-win.is-dark {\n  background: #111827;\n  color: #f9fafb;\n}\n.wp-head {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 14px;\n  border-bottom: 1px solid rgba(127, 127, 127, 0.15);\n}\n.wp-ava {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  object-fit: cover;\n  flex: none;\n}\n.wp-ava.is-letter {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #ffedd5;\n  color: #c2410c;\n  font-weight: 700;\n  font-size: 13px;\n}\n.wp-name {\n  font-weight: 700;\n  font-size: 13px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.wp-online {\n  font-size: 11px;\n  color: #16a34a;\n}\n.wp-x {\n  font-size: 12px;\n  opacity: 0.5;\n}\n.wp-msgs {\n  flex: 1;\n  padding: 12px 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  font-size: 12.5px;\n  overflow: hidden;\n}\n.wp-bot,\n.wp-me {\n  max-width: 85%;\n  padding: 8px 10px;\n  border-radius: 12px;\n  line-height: 1.4;\n}\n.wp-bot {\n  background: #f3f4f6;\n  align-self: flex-start;\n}\n.wp-win.is-dark .wp-bot {\n  background: #1f2937;\n}\n.wp-me {\n  align-self: flex-end;\n}\n.wp-input {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0 10px 10px;\n  padding: 6px 6px 6px 10px;\n  border-top: 1px solid rgba(127, 127, 127, 0.15);\n  font-size: 12px;\n  opacity: 0.85;\n}\n.wp-input > span:first-child {\n  flex: 1;\n  opacity: 0.6;\n}\n.wp-send {\n  width: 26px;\n  height: 26px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n}\n.wp-launcher {\n  position: absolute;\n  right: 14px;\n  bottom: 14px;\n  width: 52px;\n  height: 52px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);\n}\n.wp-launcher.is-left {\n  right: auto;\n  left: 14px;\n}\n.wp-invite {\n  display: flex;\n  gap: 10px;\n  align-items: flex-start;\n  background: #fff;\n  border: 1px solid var(--v2-border);\n  border-radius: 12px;\n  padding: 12px;\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.06);\n}\n.wp-invite.is-dark {\n  background: #111827;\n  color: #f9fafb;\n  border-color: #111827;\n}\n.wp-invite-text {\n  font-size: 12.5px;\n  line-height: 1.4;\n}\n@media (max-width: 1180px) {\n  .wg-side {\n    position: static;\n    max-width: none;\n  }\n}\n.v2-topbar .wg-savebar {\n  flex-wrap: nowrap;\n  min-width: 0;\n}\n.v2-topbar .wg-savebar > span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.wg-save-short {\n  display: none;\n  color: var(--v2-orange);\n  font-weight: 600;\n}\n@media (max-width: 1100px) {\n  .v2-topbar .wg-savebar > .wg-save-long {\n    display: none;\n  }\n  .v2-topbar .wg-savebar > .wg-save-short {\n    display: inline;\n  }\n}\n.wg-swatch:focus-visible,\n.wg-seg button:focus-visible,\n.wg-picker:focus-within {\n  outline: 2px solid var(--v2-blue);\n  outline-offset: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
